var a={sizes:{S:8,M:22}};export{a as default};
